export default function initM18() {
  const $ = jQuery;
  $(window).on("load", function () {
    var owl5 = $('.owl-carousel');
    owl5.owlCarousel({
      center: true,
      autoWidth: true,
      loop: true,
      items: 4,
      margin: 60,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 2000, // Reduced to make the slider start immediately
      autoplaySpeed: 6000, // Keeps the sliding speed
      nav: false,
      dots: false,
      responsive: {
        992: {
          margin: 60,
        },
        0: {
          margin: 20,
        },
      },
    });
  });
}